// extracted by mini-css-extract-plugin
export default {"no-data-cloud-invoice":"Map_no-data-cloud-invoice__5SJ-b"};